export const deDE = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Deine Kontaktmöglichkeiten",
  description:
    "Kontaktiere Lassie für Fragen zu Versicherungen, Schadensfällen oder allgemeinem Support. Wir sind per Chat, E-Mail und Telefon erreichbar.",
  mainEntity: {
    "@type": "Organization",
    name: "Lassie AB Zweigniederlassung",
    url: "https://de.lassie.co",
    logo: "https://de.lassie.co/images/logo-with-name.svg",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Münzstraße 21, Vorderhaus",
      addressLocality: "Berlin",
      postalCode: "10178",
      addressCountry: "DE",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "support@lassie.de",
        availableLanguage: "German",
        areaServed: "DE",
        hoursAvailable: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          opens: "08:00",
          closes: "22:00",
        },
      },
      {
        "@type": "ContactPoint",
        contactType: "Schadensteam - Tierkrankenversicherung",
        email: "schadenteam@lassie.de",
        availableLanguage: "German",
        areaServed: "DE",
      },
      {
        "@type": "ContactPoint",
        contactType: "Schadensteam - Haftpflichtversicherung",
        email: "haftpflichtschaden@lassie.de",
        availableLanguage: "German",
        areaServed: "DE",
      },
      {
        "@type": "ContactPoint",
        contactType: "Kooperationen",
        email: "kooperationen@lassie.de",
        availableLanguage: "German",
        areaServed: "DE",
      },
      {
        "@type": "ContactPoint",
        contactType: "Beschwerden",
        email: "beschwerde@lassie.de",
        availableLanguage: "German",
        areaServed: "DE",
      },
    ],
  },
};
